import alt from '../alt';
import FlowSource from '../sources/flow';

class FlowActions {

    setActions(actions) {
        return actions;
    }

    getActivated(tenantId) {
        FlowSource.getActivated(tenantId).then((response) => this.actions.onGetActivated(response));
    }

    onGetActivated(response) {
        return response;
    }

    open(flow) {
        return flow;
    }

    update(flow) {
        return { response: flow };
    }

    close(id) {
        return id;
    }

    openSubflow(Id) {
        return Id;
    }

    openConfig(config) {
        return config;
    }

    closeConfig(flowId) {
        return flowId;
    }

    onChange(id, tenantId, authenticationToken) {
        return { id: id, tenantId: tenantId, authenticationToken: authenticationToken }
    }
}

export default alt.createActions(FlowActions);
